import FormSelect from "../FormSelect";
import { useFetchClientServiceLevelAgreementStatusesListQuery } from "../../../services/clientserviceterms";
import React from "react";

const ClientServiceLevelAgreementStatusSelect = React.forwardRef(({cslaId = null, options, ...rest}, ref) => {
    
    const { data, error, isError, isLoading, isFetching } = useFetchClientServiceLevelAgreementStatusesListQuery({ cslaId });

    var displayOptions = data && Array.isArray(data) ? data : data?.results ?? [];

    return (<FormSelect
        options={displayOptions}
        isLoadingOptions={isLoading || isFetching}
        ref={ref}
        {...rest}
    />);
    });

export default ClientServiceLevelAgreementStatusSelect;